import axios from 'axios';
import { useEffect, useState } from 'react';
import faq from '../../../Images/faq.png';

import { apiUrl } from '../../../config/config';

const Questions = () => {
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/v1/faq`);
        setFaqs(response.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  const questions = faqs.data;

  return (
    <div>
      <section className='bg-white'>
        <div className='container px-6 py-10 mx-auto'>
          <div className='mt-8 lg:-mx-6 lg:flex lg:items-center'>
            <div className='w-full lg:mx-6 lg:w-1/2'>
              <h4 className='block mt-4 text-2xl font-semibold text-[#124265]  capitalize'>
                Answers to your common questions
              </h4>
              <p className='mt-3 text-base  dark:text-gray-400 md:text-base'>
                Our learning materials include a wide range of educational,
                professional and skill-based courses. We cover all school and
                college grade levels, as well as university courses.
              </p>
              <img
                loading='lazy'
                className='object-contain w-full lg:mx-6 lg:w-1/2 h-72 lg:h-60'
                src={faq}
                alt='faq'
              />
            </div>
            <div className='mt-6 lg:w-1/2 lg:mt-0 lg:mx-6 '>
              <div className='space-y-4'>
                <details
                  className='group rounded-lg bg-gray-50 p-6 [&_summary::-webkit-details-marker]:hidden'
                  open
                >
                  <summary className='flex items-center justify-between cursor-pointer'>
                    <h2 className='font-semibold text-gray-900'>
                      What welding courses do you offer?
                    </h2>
                    <span className='relative ml-1.5 h-5 w-5 flex-shrink-0'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        className='absolute inset-0 w-5 h-5 opacity-100 group-open:opacity-0'
                        fill='none'
                        viewBox='0 0 24 24'
                        stroke='currentColor'
                        strokeWidth='2'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          d='M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z'
                        />
                      </svg>

                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        className='absolute inset-0 w-5 h-5 opacity-0 group-open:opacity-100'
                        fill='none'
                        viewBox='0 0 24 24'
                        stroke='currentColor'
                        strokeWidth='2'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          d='M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z'
                        />
                      </svg>
                    </span>
                  </summary>
                  <p className='mt-4 leading-relaxed text-gray-500 text-justify'>
                    We provide comprehensive welding courses including Welding
                    1G to 4G, Welding 4G to 6G + TIG, 1G to TIG Complete,1G to
                    6G + MIG, Pipe Fitter, Plumber, and Shuttering Carpenter.
                    Each course is designed with practical hands-on training to
                    prepare students for real industry requirements.
                  </p>
                </details>

                <details className='group rounded-lg bg-gray-50 p-6 [&_summary::-webkit-details-marker]:hidden'>
                  <summary className='flex items-center justify-between cursor-pointer'>
                    <h2 className='font-semibold text-gray-900'>
                      Do you provide job placement abroad?
                    </h2>
                    <span className='relative ml-1.5 h-5 w-5 flex-shrink-0'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        className='absolute inset-0 w-5 h-5 opacity-100 group-open:opacity-0'
                        fill='none'
                        viewBox='0 0 24 24'
                        stroke='currentColor'
                        strokeWidth='2'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          d='M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z'
                        />
                      </svg>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        className='absolute inset-0 w-5 h-5 opacity-0 group-open:opacity-100'
                        fill='none'
                        viewBox='0 0 24 24'
                        stroke='currentColor'
                        strokeWidth='2'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          d='M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z'
                        />
                      </svg>
                    </span>
                  </summary>
                  <p className='mt-4 leading-relaxed text-gray-500 text-justify'>
                    Yes! Our institute assists students in securing welding jobs
                    abroad. We guide you through resume preparation, interviews,
                    and documentation to help you start your international
                    career smoothly.
                  </p>
                </details>

                <details className='group rounded-lg bg-gray-50 p-6 [&_summary::-webkit-details-marker]:hidden'>
                  <summary className='flex items-center justify-between cursor-pointer'>
                    <h2 className='font-semibold text-gray-900'>
                      Do I need prior experience to join?
                    </h2>
                    <span className='relative ml-1.5 h-5 w-5 flex-shrink-0'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        className='absolute inset-0 w-5 h-5 opacity-100 group-open:opacity-0'
                        fill='none'
                        viewBox='0 0 24 24'
                        stroke='currentColor'
                        strokeWidth='2'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          d='M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z'
                        />
                      </svg>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        className='absolute inset-0 w-5 h-5 opacity-0 group-open:opacity-100'
                        fill='none'
                        viewBox='0 0 24 24'
                        stroke='currentColor'
                        strokeWidth='2'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          d='M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z'
                        />
                      </svg>
                    </span>
                  </summary>
                  <p className='mt-4 leading-relaxed text-gray-500 text-justify'>
                    No prior experience is required. Our courses are structured
                    to take students from beginner to advanced levels with
                    step-by-step training and expert mentorship.
                  </p>
                </details>

                <details className='group rounded-lg bg-gray-50 p-6 [&_summary::-webkit-details-marker]:hidden'>
                  <summary className='flex items-center justify-between cursor-pointer'>
                    <h2 className='font-semibold text-gray-900'>
                      How long is the welding training course?
                    </h2>
                    <span className='relative ml-1.5 h-5 w-5 flex-shrink-0'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        className='absolute inset-0 w-5 h-5 opacity-100 group-open:opacity-0'
                        fill='none'
                        viewBox='0 0 24 24'
                        stroke='currentColor'
                        strokeWidth='2'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          d='M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z'
                        />
                      </svg>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        className='absolute inset-0 w-5 h-5 opacity-0 group-open:opacity-100'
                        fill='none'
                        viewBox='0 0 24 24'
                        stroke='currentColor'
                        strokeWidth='2'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          d='M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z'
                        />
                      </svg>
                    </span>
                  </summary>
                  <p className='mt-4 leading-relaxed text-gray-500 text-justify'>
                    The course duration depends on the program selected.
                    Typically, courses range from a few weeks to a few months,
                    with a focus on practical sessions and industry-ready
                    skills.
                  </p>
                </details>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Questions;
